import { SET_LOGIN_STATE } from './actionTypes';

export default function setNewLogin(payload) {
  return {
    type: SET_LOGIN_STATE,
    payload,
  };
}
